import {
  breakpointAnalysisUrl,
  captableUrl,
  cashFlowLedgerUrl,
  companySummaryUrl,
  documentGenerationJobsUrl,
  documentsUrl,
  financialUrl,
  fundOwnershipUrl,
  valuationUrl,
  waterfallUrl,
} from 'common/config/urls';
import { WATERFALL_SLUG, WATERFALL_TITLE } from 'common/constants/allocations';
import {
  CAP_TABLE_SLUG,
  CAP_TABLE_TITLE,
} from 'common/constants/cap-table';
import { COMPANIES_SUMMARY_SLUG, COMPANIES_SUMMARY_TITLE } from 'common/constants/companies';
import { DOCUMENTS_SLUG, DOCUMENTS_TITLE } from 'common/constants/documents';
import { FINANCIAL_SLUG, FINANCIAL_TITLE } from 'common/constants/financials';
import { VALUATIONS_SLUG, VALUATIONS_TITLE } from 'common/constants/valuations';
import { COMPANY_NAVIGATION_IDS } from './companyNavigation.constants';
import type { CompanyNavigationRoute, CompanyNavigationRouteDefinition } from './companyNavigation.types';

const COMPANY_NAVIGATION_ROUTE_DEFINITIONS: CompanyNavigationRouteDefinition[] = [
  {
    id: COMPANY_NAVIGATION_IDS.SUMMARY,
    route: companySummaryUrl,
    hidden: false,
    title: COMPANIES_SUMMARY_TITLE,
    slug: COMPANIES_SUMMARY_SLUG,
  },
  {
    id: COMPANY_NAVIGATION_IDS.FINANCIAL,
    route: financialUrl,
    hidden: false,
    title: FINANCIAL_TITLE,
    slug: FINANCIAL_SLUG,
  },
  {
    id: COMPANY_NAVIGATION_IDS.CAP_TABLE,
    route: captableUrl,
    hidden: false,
    title: CAP_TABLE_TITLE,
    slug: CAP_TABLE_SLUG,
    alsoActiveFor: [fundOwnershipUrl, breakpointAnalysisUrl, cashFlowLedgerUrl],
  },
  {
    route: valuationUrl,
    id: COMPANY_NAVIGATION_IDS.VALUATION,
    hidden: false,
    slug: VALUATIONS_SLUG,
    title: VALUATIONS_TITLE,
  },
  {
    route: waterfallUrl,
    id: COMPANY_NAVIGATION_IDS.WATERFALL,
    hidden: false,
    slug: WATERFALL_SLUG,
    title: WATERFALL_TITLE,
  },
  {
    id: COMPANY_NAVIGATION_IDS.DOCUMENTS,
    route: documentsUrl,
    hidden: false,
    slug: DOCUMENTS_SLUG,
    title: DOCUMENTS_TITLE,
    alsoActiveFor: [documentGenerationJobsUrl],
  },
];

export const COMPANY_NAVIGATION_ROUTES: CompanyNavigationRoute[] = COMPANY_NAVIGATION_ROUTE_DEFINITIONS.map((route, index) => ({
  ...route,
  itemKey: route.itemKey ?? index,
}));

export { COMPANY_SECONDARY_NAVIGATION_LOADING_ARIA_LABEL } from './companyNavigation.constants';
export {
  buildCompanyNavigationUrl,
  getCompanyNavigationQueryParams,
  isCompanyMissingMeasurementDates,
} from './companyNavigation.utilities';
export type { CompanyNavigationRoute, CompanyNavigationRouteBuilder } from './companyNavigation.types';
